export class ResponseCuentasJardinModel{
    payload:CuentasJardinModel[];

    constructor(){
        this.payload = new Array<CuentasJardinModel>();
    }
}

export class ResponseCuentasJardinPaginationModel{
    payload:paginationModel;

    constructor(){
        this.payload = new paginationModel();
    }
}

export class ResponseReporteConsolidadoModel{
    payload:paginationReporteConsolidadoModel;

    constructor(){
        this.payload = new paginationReporteConsolidadoModel();
    }
}
 
export class paginationModel{
    total:number;
    list:Array<CuentasJardinModel>;
    pageNum: number;
    pageSize: number;
    size: number;
    startRow: number;
    endRow: number;
    pages: number;
    prePage: number;
    nextPage: number;
    isFirstPage:boolean;
    isLastPage:boolean;
    hasPreviousPage:boolean;
    hasNextPage:boolean;
    navigatePages: number;
    navigatepageNums:Array<number>;
    navigateFirstPage: number;
    navigateLastPage: number;
    lastPage: number;
    firstPage: number;
    constructor(){
        this.total= 0;
        this.list= new Array<CuentasJardinModel>();
        this.pageNum= 0;
        this.pageSize= 0;
        this.size= 0;
        this.startRow= 0;
        this.endRow= 0;
        this.pages= 0;
        this.prePage= 0;
        this.nextPage= 0;
        this.isFirstPage= false;
        this.isLastPage= false;
        this.hasPreviousPage= false;
        this.hasNextPage= false;
        this.navigatePages= 0;
        this.navigatepageNums= new Array<number>();
        this.navigateFirstPage= 0;
        this.navigateLastPage= 0;
        this.lastPage= 0;
        this.firstPage= 0;
    }
}
export class CuentasJardinModel{
    bloqueo: boolean;
    codigo: number;
    comuna: string;
    id: number;
    nombre: string;
    pass: string;
    programa: string;
    region: string;
    usuario: string;
    constructor(){
        this.bloqueo= false;
        this.codigo= 0;
        this.comuna= '';
        this.id= 0;
        this.nombre= '';
        this.pass= '';
        this.programa= '';
        this.region= '';
        this.usuario= '';
    }
}



export class paginationReporteConsolidadoModel{
    total:number;
    list:Array<ReporteConsolidadoModel>;
    pageNum: number;
    pageSize: number;
    size: number;
    startRow: number;
    endRow: number;
    pages: number;
    prePage: number;
    nextPage: number;
    isFirstPage:boolean;
    isLastPage:boolean;
    hasPreviousPage:boolean;
    hasNextPage:boolean;
    navigatePages: number;
    navigatepageNums:Array<number>;
    navigateFirstPage: number;
    navigateLastPage: number;
    lastPage: number;
    firstPage: number;
    constructor(){
        this.total= 0;
        this.list= new Array<ReporteConsolidadoModel>();
        this.pageNum= 0;
        this.pageSize= 0;
        this.size= 0;
        this.startRow= 0;
        this.endRow= 0;
        this.pages= 0;
        this.prePage= 0;
        this.nextPage= 0;
        this.isFirstPage= false;
        this.isLastPage= false;
        this.hasPreviousPage= false;
        this.hasNextPage= false;
        this.navigatePages= 0;
        this.navigatepageNums= new Array<number>();
        this.navigateFirstPage= 0;
        this.navigateLastPage= 0;
        this.lastPage= 0;
        this.firstPage= 0;
    }
}

export class ReporteConsolidadoModel{
    codigo: number;
    comuna: string;
    idJardinPeriodo: number;
    nombre: string;
    programa: string;
    region: string;
    estado: string;
    constructor(){
        this.codigo= 0;
        this.comuna= '';
        this.idJardinPeriodo= 0;
        this.nombre= '';
        this.programa= '';
        this.region= '';
        this.estado= '';
    }
}


export class ResponseOtrasCuentasModel{
    payload:paginationOtrasCuentasModel;

    constructor(){
        this.payload = new paginationOtrasCuentasModel();
    }
}

export class ResponseEncargadoRegionalModel{
    payload:paginationEncargadoRegionalModel;

    constructor(){
        this.payload = new paginationEncargadoRegionalModel();
    }
}


export class paginationEncargadoRegionalModel{
    total:number;
    list:Array<EncargadoRegionalModel>;
    pageNum: number;
    pageSize: number;
    size: number;
    startRow: number;
    endRow: number;
    pages: number;
    prePage: number;
    nextPage: number;
    isFirstPage:boolean;
    isLastPage:boolean;
    hasPreviousPage:boolean;
    hasNextPage:boolean;
    navigatePages: number;
    navigatepageNums:Array<number>;
    navigateFirstPage: number;
    navigateLastPage: number;
    lastPage: number;
    firstPage: number;
    constructor(){
        this.total= 0;
        this.list= new Array<EncargadoRegionalModel>();
        this.pageNum= 0;
        this.pageSize= 0;
        this.size= 0;
        this.startRow= 0;
        this.endRow= 0;
        this.pages= 0;
        this.prePage= 0;
        this.nextPage= 0;
        this.isFirstPage= false;
        this.isLastPage= false;
        this.hasPreviousPage= false;
        this.hasNextPage= false;
        this.navigatePages= 0;
        this.navigatepageNums= new Array<number>();
        this.navigateFirstPage= 0;
        this.navigateLastPage= 0;
        this.lastPage= 0;
        this.firstPage= 0;
    }
}



 
export class OtrasCuentasModel{
    id: number;
    region: string;
    perfil: string;
    estamento: string;
    codigoJardin: number;
    nombreJardin: string;
    nombres: string;
    apellidos: string;
    correo: string;
    usuario: string;
    password: string;
    bloqueo: boolean;

    constructor(){
        this.id = 0;
        this.region = '';
        this.perfil = '';
        this.estamento = '';
        this.codigoJardin = 0;
        this.nombreJardin = '';
        this.nombres = '';
        this.apellidos = '';
        this.correo = '';
        this.usuario = '';
        this.password = '';
        this.bloqueo = false;
    }
}
 
export class EncargadoRegionalModel{
    idPersonaPeriodo: number;
    idPersona: number;
    idUsuario: number;
    rut: string;
    region: Region;
    nombre: string;
    apellidoPaterno: string;
    apellidoMaterno: string;
    email: string;
    usuario: string;
    contrasena: string;
    bloqueo: boolean;

    constructor(){
        this.idPersonaPeriodo = 0;
        this.idPersona = 0;
        this.idUsuario = 0;
        this.region = new Region;
        this.nombre = '';
        this.apellidoPaterno = '';
        this.apellidoMaterno = '';
        this.email = '';
        this.usuario = '';
        this.contrasena = '';
        this.bloqueo = false;
        this.rut = '';
    }
}

export class Region{
    idRegion: number;
    nombre: string;

    constructor(){
        this.idRegion = -1;
        this.nombre = '';
    }
}

export class paginationOtrasCuentasModel{
    total:number;
    list:Array<OtrasCuentasModel>;
    pageNum: number;
    pageSize: number;
    size: number;
    startRow: number;
    endRow: number;
    pages: number;
    prePage: number;
    nextPage: number;
    isFirstPage:boolean;
    isLastPage:boolean;
    hasPreviousPage:boolean;
    hasNextPage:boolean;
    navigatePages: number;
    navigatepageNums:Array<number>;
    navigateFirstPage: number;
    navigateLastPage: number;
    lastPage: number;
    firstPage: number;
    constructor(){
        this.total= 0;
        this.list= new Array<OtrasCuentasModel>();
        this.pageNum= 0;
        this.pageSize= 0;
        this.size= 0;
        this.startRow= 0;
        this.endRow= 0;
        this.pages= 0;
        this.prePage= 0;
        this.nextPage= 0;
        this.isFirstPage= false;
        this.isLastPage= false;
        this.hasPreviousPage= false;
        this.hasNextPage= false;
        this.navigatePages= 0;
        this.navigatepageNums= new Array<number>();
        this.navigateFirstPage= 0;
        this.navigateLastPage= 0;
        this.lastPage= 0;
        this.firstPage= 0;
    }
}

export class ResponseCuentaJardinPeriodoModel{
    payload: CuentaJardinPeriodoModel;

    constructor(){
        this.payload = new CuentaJardinPeriodoModel();
    }
}

export class CuentaJardinPeriodoModel{
    codigo: number;
    comuna: number;
    correoInstitucional: string;
    correoPersona: string;
    direccion: string;
    idJardinPeriodo: number;
    modalidad: number;
    nombreDirectora: string;
    nombreJardin: string;
    programa: string;
    region: number;
    rut: string;
    telefono: string;
    telefonoDirectora: string;

    constructor(){
        this.codigo = null;
        this.comuna = 0;
        this.correoInstitucional = '';
        this.correoPersona = '';
        this.direccion = '';
        this.idJardinPeriodo = null;
        this.modalidad = 0;
        this.nombreDirectora = '';
        this.nombreJardin = '';
        this.programa = '';
        this.region = 0;
        this.rut = '';
        this.telefono = '';
        this.telefonoDirectora = '';
    }
}


export class ResponseCuentasModel{

    payload: CuentasModel;

    constructor(){
        this.payload = new CuentasModel();
    }
}

export class CuentasModel{

    estamentos: TablaMaestraModel;
    programas: TablaMaestraModel[];
    modalidades: TablaMaestraModel[];
    regiones: RegionModel[];

    constructor(){
        this.estamentos = new TablaMaestraModel();
        this.programas = new Array<TablaMaestraModel>();
        this.modalidades = new Array<TablaMaestraModel>();
        this.regiones = new Array<RegionModel>();
    }
}

export class ConsolidadoModel{

}

export class TablaMaestraModel{
    idTablaMaestra : number;
    discriminador :  number;
    descripcionCorta : string;
    descripcionLarga : string;
    agrupador : number;

    constructor(){
        this.idTablaMaestra = 0;
        this.discriminador = 0;
        this.descripcionCorta = '';
        this.descripcionLarga = '';
        this.agrupador = 0;
    }
}
 
export class RegionModel{
    idRegion : number;
    nombre : string;
    comunas: ComunaModel[];

    constructor(){
        this.idRegion = 0;
        this.nombre = '';
        this.comunas = Array<ComunaModel>();
    }
}

export class ComunaModel{
    idComuna : number;    
    nombre : string;
    region : ComunaRegionModel

    constructor(){
        this.idComuna = 0;
        this.nombre = '';
        this.region = new ComunaRegionModel();
    }
}

export class ComunaRegionModel{
    idRegion : number;
    nombre : string;
    simbolo : number;
    orden : number;

    constructor(){
        this.idRegion = 0;
        this.nombre = '';
        this.simbolo = 0;
        this.orden = 0;
    }
}

export class CuentaUsuarioModel{
    apellidoMaterno: string;
    apellidoPaterno: string;
    comuna: number;
    correo: string;
    estamento: number;
    idPersona: number;
    nombre: string;
    region: number;
    rut: string;

    constructor(){
        this.apellidoMaterno = '';
        this.apellidoPaterno = '';
        this.comuna = 0;
        this.correo = '';
        this.estamento = 0;
        this.idPersona = 0;
        this.nombre = '';
        this.region = 0
        this.rut = '';
    }
}